/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StreamListModelDto } from '../../models/stream-list-model-dto';

export interface IntegrationsControllerGetStreams$Params {
}

export function integrationsControllerGetStreams(http: HttpClient, rootUrl: string, params?: IntegrationsControllerGetStreams$Params, context?: HttpContext): Observable<StrictHttpResponse<StreamListModelDto>> {
  const rb = new RequestBuilder(rootUrl, integrationsControllerGetStreams.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StreamListModelDto>;
    })
  );
}

integrationsControllerGetStreams.PATH = '/integrations/streams';
